import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./utils/vant-ui";
Vue.config.productionTip = false;
import { Dialog } from "vant";
import checkAJB from "./utils/JSBridge";
// 导入less style
import "@/assets/css/index.less";
import store from "./store";


import axios from 'axios'
Vue.prototype.$http = axios
// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
// Vue.use(vConsole)

import { request } from "@/utils/request.js";
Vue.prototype.request = request;

Vue.prototype.$Dialog = Dialog;

Vue.prototype.checkAJB = checkAJB;
new Vue({
	router,
	store,
	render: h => h(App)
}).$mount("#app");
